<template>
    <div>
        <input-form v-show="showForm" ref="userForm" :opt="operat"></input-form>
        <input-confirm v-show="!showForm" ref="userConfirm" :form="reqForm" :opt="operat"></input-confirm>
        <success-msg ref="success" :lev="lev" :msg="msg" @ok="msgOk"></success-msg>
    </div>
</template>

<script>
    import {isWarningProjFinishDate
           ,isOverProjFinishDate
           ,isOverProjStartDate} from 'pages/commons/form/comFunc'
    import InputForm from './components/Form'
    import InputConfirm from './components/Confirm'
    import SuccessMsg from 'pages/commons/modal/infoMsg/InfoMsg'
    import {getList, converVal} from 'pages/commons/form/selectList'
    import {mapGetters} from 'vuex'

    export default {
        components: {
            InputForm,
            InputConfirm,
            SuccessMsg
        },
        data () {
            return {
                msg: "",
                lev: 0,
                operat: this.initOperat(),
                showForm: this.initShow(),
                reqForm: {},
                reqFormBk: {},//show->edit->confirm->show時、showのデータ表示が上書きしないよう保持する
            }
        },
        created () {
            // リフレッシュ後listObjがなくなる為、reflectで一覧画面のリストに追加する際にエラーとなる
            // sessionに保存しておく
            this.$store.dispatch('setListObjSession')
        },
        mounted() {
            this.loadCmpProjInfo()
        },
        watch: {
            // サーバーエラーで画面制御
            getCmpProjOperat (operat) {
                this.changeOperat(operat, 'success')
            },
            getCmpProjInfo (info) {
                if (info.data.proj) {
                    this.reqForm = info.data.proj
                    this.reqFormBk = info.data.proj
                }
            },
            getCmpProjInfoLoadStatus (status) {
                if (status == '1') {
                    this.$store.dispatch('startProgress')
                }
                if (status == '2') {
                    this.$store.dispatch('doneProgress')
                }
                if (status == '3') {
                    this.$store.dispatch('doneProgress')
                }
            },
            getSaveCmpProjInfoStatus (status) {
                if (status == '1') {
                    this.$store.dispatch('startSpinner')
                }
                if (status == '2') {
                    // 新規・更新した案件を一覧リストに反映
                    this.$store.dispatch('reflectList', this.getCmpProjInfo.data.proj)
                    this.$store.dispatch('doneSpinner')
                    this.openMsg()
                }
                if (status == '3') {
                    this.$store.dispatch('doneSpinner')
                }
            }
        },
        computed: {
            ...mapGetters(['getSaveCmpProjInfoStatus', 'getCmpProjOperat', 'getCmpProjInfoLoadStatus', 'getCmpProjInfo'])
        },
        methods: {
            loadCmpProjInfo () {
                    this.$store.dispatch('loadCmpProjInfo', {
                        id: this.$route.params.id
                    })
            },
            doSubmit () {
                this.reqForm['operat'] = this.operat

                if (this.operat == 'edit_confirm' 
                    || this.operat == 'create_confirm') {
                    this.$store.dispatch('saveCmpProjInfo', this.reqForm)
                }
            },
            getChildData () {
                let userForm = this.$refs.userForm.getData()
                this.reqForm = Object.assign({}, this.reqForm, userForm)
            },
            openMsg (msg="完了しました。", lev=0) {
                this.msg = msg
                this.lev = lev
                this.$refs.success.openThis()
            },
            initOperat () {
                return this.$route.params.do
            },
            initShow () {
                return this.$route.params.do == 'create' ? true : false
            },
            changeOperat (opt, res="") {
                if (opt == 'auto') {
                    this.operat = (this.operat == 'create') ? 'create_confirm' : 'edit_confirm'
                } else {
                    this.operat = opt 
                }
                if (this.operat == 'create' || this.operat == 'edit') {
                    this.showForm = true
                }
                if (this.operat == 'create_confirm' || this.operat == 'edit_confirm' || this.operat == 'show') {
                    this.showForm = false

                    // showのデータを上書きされないよう復旧する
                    // save後、最新のデータ(reqForm)で表示する
                    if (this.operat == 'show' && res !='success') {
                        this.reqForm = this.reqFormBk
                    }
                }
                // スクロールをトップへ移動
                document.documentElement.scrollTop = 0
            },
            getList (name) {
                return getList(name)
            },
            converVal (name, val) {
                return converVal(name,val)
            },
            isWarnFinish (val) {
                return isWarningProjFinishDate(val)
            },
            isOverFinish (val) {
                return isOverProjFinishDate(val)
            },
            isOverStart (val) {
                return isOverProjStartDate(val)
            },
            msgOk () {
                this.$refs.userForm.setMakedSummary()
            }
        }
    }
</script>

<style></style>
